import { Client } from '@finanzcheck/catalyst-pollard'

const pollard = new Client({ target: 'parent' })

export default pollard
